module.exports = __webpack_public_path__ + "img/add-file.7995dd45.svg";